import { createSlice } from "@reduxjs/toolkit";

const filterReducer = createSlice({
  name: "filter",
  initialState: {
    // Products page filters
    productsFilters: {
      searchValue: "",
      selectedCategory: "all",
      currentPage: 1,
      parPage: 25,
      viewMode: "table"
    }
  },
  reducers: {
    // Save products page filters
    saveProductsFilters: (state, action) => {
      state.productsFilters = {
        ...state.productsFilters,
        ...action.payload
      };
    },
    
    // Clear all filters
    clearAllFilters: (state) => {
      state.productsFilters = {
        searchValue: "",
        selectedCategory: "all",
        currentPage: 1,
        parPage: 25,
        viewMode: "table"
      };
    },
    
    // Reset to default filters
    resetProductsFilters: (state) => {
      state.productsFilters = {
        searchValue: "",
        selectedCategory: "all",
        currentPage: 1,
        parPage: 25,
        viewMode: "table"
      };
    }
  }
});

export const { 
  saveProductsFilters, 
  clearAllFilters, 
  resetProductsFilters 
} = filterReducer.actions;

export default filterReducer.reducer;
